import { useIntl } from 'react-intl';

import CommentIcon from '@atlaskit/icon/core/comment';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
import { token } from '@atlaskit/tokens';

import { LoggedInJiraWhiteTemplateUpgradeEligibleUser } from '../components/logged-in-jira-upgrade-eligible-user';

export const LoggedInJiraStandardUpgradeEligibleUser = () => {
	const { formatMessage } = useIntl();

	return (
		<LoggedInJiraWhiteTemplateUpgradeEligibleUser
			productEditionText={formatMessage({
				id: `WacSignupForm.cloudStandard`,
				defaultMessage: 'Cloud Standard',
			})}
			textHeading={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeTitle',
				defaultMessage: 'Upgrade to the Standard plan',
			})}
			textBody={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeBody',
				defaultMessage:
					'Get a free 14-day trial of Jira Standard for unlimited users, additional storage, and much more. Cancel anytime.',
			})}
			valuePropsHeading={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardBulletIntro',
				defaultMessage: 'The Standard plan also includes:',
			})}
			valueProps={[
				{
					icon: <LockLockedIcon color={token('color.icon.brand')} label="PersonAdd" />,
					heading: formatMessage({
						id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Title',
						defaultMessage: 'User roles & permissions',
					}),
					body: formatMessage({
						id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Body',
						defaultMessage:
							'Have more control over which users have access to different projects and actions.',
					}),
				},
				{
					icon: <PersonAvatarIcon color={token('color.icon.brand')} label="PersonAdd" />,
					heading: formatMessage({
						id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Title',
						defaultMessage: 'Anonymous access',
					}),
					body: formatMessage({
						id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Body',
						defaultMessage: 'Give secure access to people outside your team.',
					}),
				},
				{
					icon: <CommentIcon color={token('color.icon.brand')} label="Comment" />,
					heading: formatMessage({
						id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Title',
						defaultMessage: 'Business hour support',
					}),
					body: formatMessage({
						id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Body',
						defaultMessage: 'Get support from Atlassian’s team of experts.',
					}),
				},
			]}
		/>
	);
};
